const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

export function hasAnalyticsConsent() {
  return window.localStorage.getItem("queme_cookie_consent") === "accepted";
}

export function trackEvent(name, params = {}) {
  if (!GA_ID || !hasAnalyticsConsent()) return;
  window.gtag?.("event", name, params);
}

export function initializeAnalytics() {
  if (!GA_ID || !hasAnalyticsConsent() || window.__quemeAnalyticsLoaded) return;
  window.__quemeAnalyticsLoaded = true;
  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(script);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() { window.dataLayer.push(arguments); };
  window.gtag("js", new Date());
  window.gtag("config", GA_ID, { send_page_view: true });
}

